<template>
	<event-assignments-page url="/v1/views/operation-planner"
								  :title="t('label.operation_planner')"
								  :feature-title="t('view.operation_planner.title')"
								  :feature-description="t('view.operation_planner.description')"
								  :community-feature-title="t('view.operation_planner.community.title')"
								  :community-feature-description="t('view.operation_planner.community.description')"
								  feature-image="/features/athletes/operation-planner.svg"
								  :item-link="{to: '/jobs/events', text: t('label.job_portal')}"
								  :index-item-link="{to: '/jobs/events', text: t('label.job_portal')}"
							:my-tab-title="t('label.my_operations')"
							:color="$config.public.colors.jobs">
		<template #assignment_skeletons="{isCommunityView}">
			<assignment-position-list-item-skeleton :has-to="!isCommunityView"/>
		</template>

		<template v-if="$auth.loggedIn" #default="{isCommunityView}">
			<client-only>
				<container-fab-btn :visible="!isCommunityView" :hide-on-scroll="!$device.isDesktop">
					<btn @click="isDownloadModalActive = true"
						 shadow
						 small
						 rounded-large
						 color="success">
						<icon :icon="icons.download"/>
						<span>{{ $t('action.add_to_calendar') }}</span>
					</btn>
				</container-fab-btn>

				<download-calendar-modal v-model="isDownloadModalActive"
									   :action="`/v1/athletes/${$auth.id}/operation-planner/download`" analytics-type="operation-planner"/>
			</client-only>
		</template>
	</event-assignments-page>
</template>

<script setup lang="ts">
import {downloadIcon} from "@spoferan/nuxt-spoferan/icons";

const {t} = useI18n();

const icons = {
	download: downloadIcon
}

const isDownloadModalActive = ref(false);

useMeta({
	title: t('view.operation_planner.title'),
	description: t('view.operation_planner.description'),
})

</script>

